import { useEffect, useRef } from 'react';
import { LeadForm } from './CtaBanner';
import { Ic } from './Icon';
import type { LandingContent } from './content';

interface Props {
  c: LandingContent;
  open: boolean;
  onClose: () => void;
}

export function DemoModal({ c, open, onClose }: Props) {
  const lastFocus = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!open) return;
    lastFocus.current = document.activeElement as HTMLElement | null;
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      lastFocus.current?.focus?.();
    };
  }, [open, onClose]);

  return (
    <div className={`lp-modal${open ? ' open' : ''}`} role="dialog" aria-modal="true" aria-labelledby="demoModalTitle" aria-hidden={!open}>
      <div className="bd" onClick={onClose} />
      <div className="dlg">
        <button type="button" className="icon-btn x" onClick={onClose} aria-label="Close" tabIndex={open ? 0 : -1}>
          <Ic name="x" />
        </button>
        <h3 id="demoModalTitle" style={{ fontSize: 21.6, paddingInlineEnd: 48 }}>
          {c.modal.title}
        </h3>
        <p style={{ color: 'var(--muted)', fontSize: 14, marginTop: 6 }}>{c.modal.sub}</p>
        {/* Remount on open so the form resets and the name field receives focus. */}
        {open ? <LeadForm c={c} idPrefix="modalForm" modal autoFocusName /> : null}
      </div>
    </div>
  );
}
